var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEbay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "eBay logo",
    width: 1000,
    height: 400.751,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M633.078 212.533c-45.439 1.49-73.671 9.69-73.671 39.62 0 19.375 15.447 40.38 54.663 40.38 52.577 0 80.642-28.658 80.642-75.662l.003-5.17c-18.433 0-41.164.16-61.637.832zm111.751 62.103c0 14.583.422 28.978 1.694 41.94H699.91c-1.243-10.673-1.697-21.279-1.697-31.566-25.202 30.98-55.178 39.885-96.762 39.885-61.676 0-94.7-32.6-94.7-70.306 0-54.613 44.915-73.868 122.89-75.654 21.323-.487 45.274-.56 65.075-.56l-.003-5.335c0-36.561-23.444-51.594-64.068-51.594-30.158 0-52.385 12.48-54.676 34.047h-52.652c5.573-53.772 62.067-67.371 111.74-67.371 59.509 0 109.773 21.173 109.773 84.115z",
    fill: "#ffbc13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M199.636 185.866c-1.944-46.877-35.78-64.42-71.941-64.42-38.994 0-70.127 19.733-75.58 64.42zM51.034 219.191c2.705 45.484 34.07 72.384 77.198 72.384 29.88 0 56.46-12.175 65.36-38.66h51.684c-10.052 53.74-67.154 71.98-116.303 71.98C39.606 324.895 0 275.68 0 209.307 0 136.242 40.966 88.122 129.788 88.122c70.699 0 122.5 37 122.5 117.756v13.313z",
    fill: "#f12c2d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.832 290.623c46.572 0 78.44-33.521 78.44-84.108 0-50.582-31.868-84.109-78.44-84.109-46.31 0-78.444 33.527-78.444 84.109 0 50.587 32.133 84.108 78.444 84.108zM252.285 0h50.103l-.005 125.877c24.557-29.26 58.389-37.755 91.69-37.755 55.835 0 117.851 37.677 117.851 119.029 0 68.122-49.322 117.744-118.781 117.744-36.357 0-70.58-13.042-91.687-38.882 0 10.32-.576 20.723-1.705 30.564H250.58c.855-15.91 1.705-35.719 1.705-51.747z",
    fill: "#0968f6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1000 96.457L845.055 400.751H788.95l44.547-84.495L716.89 96.457h58.627l85.805 171.731 85.562-171.73z",
    fill: "#93c822"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEbay);
export default __webpack_public_path__ + "static/media/logo-ebay.73483514d5f167ed33c67e66e36b15a8.svg";
export { ForwardRef as ReactComponent };